import React from 'react';

import { Box, Typography } from '@material-ui/core';

import { InvitePayScheme } from '@vyce/core/src/api/types';
import { HowToEngageEmployee } from '@vyce/core/src/components/HowToEngageEmployee';
import { SUBCONTRACTOR_TYPES } from '@vyce/core/src/constants';
import { PaySchedule } from '@vyce/core/src/types';

import useStyles from '../../styles';
import { TargetCheckboxGrid } from './TargetCheckboxGrid';

interface Props {
  paySchedules: PaySchedule[];
  selectedIds: string[];
  payScheme: InvitePayScheme | null;
  showSchemeError: boolean;
  onToggle: (id: string, checked: boolean) => void;
  onToggleAll: (checked: boolean) => void;
  onSchemeChange: (scheme: InvitePayScheme | null) => void;
}

export const PayrollTargetSection: React.FC<Props> = ({
  paySchedules,
  selectedIds,
  payScheme,
  showSchemeError,
  onToggle,
  onToggleAll,
  onSchemeChange,
}) => {
  const classes = useStyles();

  // HowToEngageEmployee offers the two schemes the product supports today; the wire type
  // also knows paye and umbrella for when that changes
  const handleTypeChange = (type: SUBCONTRACTOR_TYPES, checked: boolean) => {
    onSchemeChange(checked ? (String(type) as InvitePayScheme) : null);
  };

  return (
    <>
      <Box marginBottom={2}>
        <HowToEngageEmployee
          selectedSubcontractorType={payScheme ?? ''}
          handleTypeChange={handleTypeChange}
        />
        {showSchemeError && (
          <Typography className={classes.sectionError}>Choose how to engage them first.</Typography>
        )}
      </Box>

      <Typography className={classes.detailsTitle}>Which pay schedules?</Typography>
      <TargetCheckboxGrid
        items={paySchedules.map(schedule => ({ id: schedule.uuid as string, name: schedule.name }))}
        selectedIds={selectedIds}
        onToggle={onToggle}
        allLabel="All pay schedules"
        onToggleAll={onToggleAll}
      />
    </>
  );
};
